export class ExchangeRatesRequest {
    id:number;
    effectiveFrom:Date;
    createdUser:string;
    updatedUser:string;
    exchangeRate: number;
    currencyId:number;
    currencyName?:string;
    isActive?:boolean;
    constructor(id:number,effectiveFrom:Date,createdUser:string,updatedUser:string, exchangeRate: number,currencyId:number,currencyName?:string,isActive?: boolean){
        this.id = id
        this.currencyId = currencyId
        this.effectiveFrom = effectiveFrom
        this.createdUser = createdUser
        this.updatedUser = updatedUser
        this.currencyName = currencyName
        this.exchangeRate = exchangeRate
        this.isActive = isActive
    }
}

export class ExchangeIdReq{
    id?:number;
    isActive?: boolean;
    fromDate?: Date
    toDate?: Date
    constructor(id?:number,isActive?: boolean, fromDate?:Date, toDate?: Date){
        this.isActive = isActive
        this.id = id
        this.fromDate = fromDate
        this.toDate = toDate
    }
}